import { NavLink, Redirect, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import * as React from 'react'
import { Menu } from 'semantic-ui-react'

import ExternalRecruitersSettingsPage from './ExternalRecruitersSettingsPage'
import RecruitersSettingsPage from './RecruitersSettingsPage'
import MetadataSettingsPage from './MetadataSettingsPage'
import AccessControlSettingsPage from './AccessControlSettingsPage'
import NoteTemplatesSettingsPage from './NoteTemplatesSettingsPage'
import EmailSyncSettingsPage from './EmailSyncSettingsPage'
import EmailTemplatesSettingsPage from './EmailTemplatesSettingsPage'
import featureToggles from '../../featureToggles'

const BASE_PATH = 'settings'

export default function SettingsPage() {
  return (
    <>
      <Helmet>
        <title>Settings</title>
      </Helmet>

      <div className="flex gap-x-2">
        <div className="sticky top-0 w-[250px] shrink-0 self-start px-6 pb-6 pt-20">
          <Menu vertical secondary className="no-overrides">
            <Menu.Item header content="Global Settings" />
            <Menu.Item
              content="Access Control"
              to={`/${BASE_PATH}/access-control`}
              as={NavLink}
            />
            <Menu.Item
              content="External Recruiters"
              to={`/${BASE_PATH}/external-recruiters`}
              as={NavLink}
            />
            <Menu.Item
              content="Recruiters"
              to={`/${BASE_PATH}/recruiters`}
              as={NavLink}
            />
            <Menu.Item
              content="Metadata"
              to={`/${BASE_PATH}/metadata`}
              as={NavLink}
            />
            <Menu.Item
              content="Note Templates"
              to={`/${BASE_PATH}/note-templates`}
              as={NavLink}
            />
            <Menu.Item className="!pt-6" header content="E-mail Settings" />
            <Menu.Item
              key="email-templates"
              content="Templates"
              to={`/${BASE_PATH}/email-templates`}
              as={NavLink}
            />
            {featureToggles.emails && [
              <Menu.Item
                key="email-sync"
                content="E-mail Sync"
                to={`/${BASE_PATH}/email-sync`}
                as={NavLink}
              />,
            ]}
          </Menu>
        </div>

        <div className="grow">
          <Route path={`/${BASE_PATH}/access-control`}>
            <AccessControlSettingsPage />
          </Route>

          <Route path={`/${BASE_PATH}/external-recruiters`}>
            <ExternalRecruitersSettingsPage />
          </Route>

          <Route path={`/${BASE_PATH}/recruiters`}>
            <RecruitersSettingsPage />
          </Route>

          <Route path={`/${BASE_PATH}/metadata`}>
            <MetadataSettingsPage />
          </Route>

          <Route path={`/${BASE_PATH}/note-templates/:templateId?`}>
            <NoteTemplatesSettingsPage />
          </Route>

          <Route path={`/${BASE_PATH}/email-sync`}>
            <EmailSyncSettingsPage />
          </Route>

          <Route path={`/${BASE_PATH}/email-templates/:templateId?`}>
            <EmailTemplatesSettingsPage />
          </Route>

          <Route exact path="/settings">
            <Redirect to={`/${BASE_PATH}/access-control`} />
          </Route>
        </div>
      </div>
    </>
  )
}
